

















































import Vue from 'vue';
import { ModalType, NotificationModal, EventType } from '@/constants';
import { NotificationModalData } from '@/types';

export default Vue.extend({
  name: 'NotificationModal',
  data () {
    return {
      ModalType,
      EventType
    };
  },
  props: {
    modalType: {
      type: String,
      required: true
    },
    documentTitle: {
      type: String,
      required: false
    }
  },
  computed: {
    modalData (): NotificationModalData {
      return NotificationModal(this.documentTitle)[this.modalType as ModalType];
    }
  }
});
